import React from 'react'

export const MandatoryField = () => {
    return (
        <span style={{ color: "red", marginLeft: "3px" }}>*</span>
    )
}
